import {createSlice} from '@reduxjs/toolkit';

export type EditorSettingsState = {
    hasFormattingBar: boolean;
}

const initialState: EditorSettingsState = {
    hasFormattingBar: true,
};

export const editorSettingsSlice = createSlice({
    name: 'editorSettings',
    initialState,
    reducers: {
        toggleFormattingBar: (state) => {
            state.hasFormattingBar = !state.hasFormattingBar;
        },
    },
});

export const {toggleFormattingBar} = editorSettingsSlice.actions;
